export default "__VITE_ASSET__09b0a335__"